import './bootstrap';

import shortSlider from './app/short-slider';
import historySlider from './app/history-slider';
import form from "./app/form";
import selectpicker from "./app/selectpicker";
import shares from "./app/shares";
import sticky from "./app/sticky";
import homeSlider from "./app/home-slider";
import gallerySlider from "./app/gallery-slider";
import lightgallery from "./app/lightgallery";
import commonSliders from "./app/common-sliders";
import scrollbar from "./app/scrollbar";
import menuMobile from "./app/menu-mobile";
import blog from "./app/blog";
import headroom from "./app/headroom";

$(document).ready(function () {
    shortSlider.init();
    historySlider.init();
    form.init();
    selectpicker.init();
    shares.init();
    sticky.init();
    homeSlider.init();
    gallerySlider.init();
    lightgallery.init();
    commonSliders.init();
    menuMobile.init();
    blog.init();
    headroom.init();
    setTimeout(() => {
        scrollbar.init();
    }, 200);
});


import Vue from 'vue';
import Services from './components/services/Services.vue';
import VueMatchHeights from 'vue-match-heights';

Vue.use(VueMatchHeights, {
    disabled: [768], // Optional: default viewports widths to disabled resizing on. Can be overridden per usage
});

const app = new Vue({
    el: '#app',
    components: {
        Services,
    }
})